import { useEffect } from 'react';

import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { StackLayout } from '@leagueplatform/genesis-core';
import { HeroSection } from 'components/hero-section/hero-section.component';
import { SecuritySettingsList } from 'components/security-settings/security-settings-list.component';
import { useGoBack } from 'hooks/use-go-back.hook';
import { sendSettingsScreenLoadedEvent } from 'utils/analytics-events';

const LAYOUT_MAX_WIDTH = 830;
const TITLE = 'STR_SECURITY_SETTINGS';

const SecuritySettingsPage = () => {
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: TITLE }));
  const { handleGoBack } = useGoBack();

  // Track screen loaded event
  useEffect(() => {
    sendSettingsScreenLoadedEvent('security settings');
  }, []);

  return (
    <MainPageContainer width="100%">
      <HeroSection title={formatMessage({ id: TITLE })} goBack={handleGoBack} />
      <StackLayout
        css={{
          maxWidth: LAYOUT_MAX_WIDTH,
          marginY: '$four',
        }}
      >
        <SecuritySettingsList />
      </StackLayout>
    </MainPageContainer>
  );
};

export default SecuritySettingsPage;
